/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'madness',
    quality: 0,
    willpower: -3,
    magicalGravity: 1.0
}